import { format, parse, isValid } from "date-fns";

export function formatDataRetention(value: string | null | undefined): string {
  if (!value) return "";
  const parsed = parse(value, "yyyy-MM-dd", new Date());
  return isValid(parsed) ? format(parsed, "MMM d, yyyy") : "";
}
